export default {
    banner_one: '让每一个中文学习者，都能体会到学习中文的乐趣',
    banner_two: '线上实时互动教学平台，让孩子在家自在学习',

    team: '我们的团队',
    team_item1_title: '哈兔介绍',
    team_item1_intro: '为孩子制定专业化、个性化的学习方案，你想要的我们都有',
    team_item2_title: '教学导师',
    team_item2_intro: '给予定期学习反馈，提供专业指导建议，做外教和孩子沟通的贴心助手',
    team_item3_title: '教研',
    team_item3_intro: '严谨科学、活泼有趣，将先进的教育理念渗透到教材的每一个细节',
    team_item4_title: '市场',
    team_item4_intro: '用心沟通，用爱灌溉，让更多中国孩子获得均等的英语学习机会',
    team_item5_title: '产品',
    team_item5_intro: '以用户体验为导向，让所有人满意是我们的尊严',
    team_item6_title: '技术',
    team_item6_intro: '用代码保证孩子优质的上课体验，是我们坚定不移的初心',

    speak: '院长致辞',
    speak_text: '普通人也能公平地享受到高品质的语言学习体验。世界的每个角落，都将有我们的学习者。因为哈兔，人们都可以自如表达，愉快沟通。人们掌握了更好的语言技能，有了更好的沟通能力，成为对社会更有用的人，共同创造我们更美好的世界。因为哈兔，世界绽放出更多笑脸。',

    taget: '目标、使命',
    taget_text: '哈兔中文网络学院作为面向海外华人华侨子女和全球汉语爱好者的中文在线教育平台，自创立之初就把引导海外人士学习和使用中文，传播中华文化、助推中华文化繁荣和复兴作为使命。此外，哈兔还呼吁发挥政府和民间团体的力量共同弘扬和传承中国文化，并且--直用切实行动与多个侨商组织合作，推进海外华人华侨子女学习中文、体验中华文化的进程。哈兔中文网络学院作为面向海外华人华侨子女和全球汉语爱好者的中文在线教育平台，自创立之初就把引导海外人士学习和使用中文，传播中华文化、助推中华文化繁荣和复兴作为使命。此外，哈兔还呼吁发挥政府和民间团体的力量共同弘扬和传承中国文化，并且--直用切实行动与多个侨商组织合作，推进海外华人华侨子女学习中文、体验中华文化的进程。哈兔中文网络学院作为面向海外华人华侨子女和全球汉语爱好者的中文在线教育平台，自创立之初就把引导海外人士学习和使用中文，传播中华文化、助推中华文化繁荣和复兴作为使命。',
    our_title: '我们的团队',

    intro: '企业大事记',
    intro_sub: '我们一直在路上，从未停止过...',

    news: '公司新闻动态',
    news_more: '更多',
    news_btn: '免费试读',

    class: '课程顾问',
    class_part1: '哈兔中文网络学院已成立7年，是全球最具影响力的中文在线教育平台。哈兔中文充分利用互联网技术，专注为海外华人华侨子女和有中文学习需求的外国人提供线上中文教育、中华文化学习、中外文化交流等综合性服务，帮助世界各地的中文学习者以高效、便捷的方式学好中文、了解中国、了解中国文化。',
    class_part2: '哈兔中文课程体系经由哈兔教研部自主研发，科学分级、严谨编排，使学员在尽可能短的时间爱上中文，掌握中文。团队自主研发了多个体系教材，有针对海外华人华侨子女的《从零到一》，也有面对零基础外国青少儿的《Zero to One》for juniors和成人课程《Zero to One》for adults，更有大量的文化兴趣课程。',
    class_part3: '截至目前，哈兔学员已突破30000人，遍布全球五大洲70个国家和地区，并即将成为联合国总部中文教育服务供应商之一。',
}